import clsx from 'clsx';
import { Highlight } from '@hungryroot/pho';
import { Heading, Paragraph } from '@hungryroot/ramen';
import styles from './IconHighlightText.module.css';

export const IconHighlightText = ({
  icon,
  highlightedText,
  text,
  className,
  highlightClassName,
}: {
  icon: React.ReactNode;
  highlightedText: string;
  text: string;
  className?: string;
  highlightClassName?: string;
}) => {
  return (
    <div className={clsx(styles.container, className)}>
      {icon}
      <div>
        <Highlight className={highlightClassName}>
          <Heading variant="H6" as="span">
            {highlightedText}
          </Heading>
        </Highlight>
        <Paragraph as="span" className={styles.text}>
          {text}
        </Paragraph>
      </div>
    </div>
  );
};
